import React, {Component} from 'react'
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CDataTable,
  CButton
} from '@coreui/react';
import { NavLink } from "react-router-dom";
import { apiRequest } from "../../services/api-request";
import deleteIcon from "../../../src/assets/close.png";
import "./dateStyles.css";

const fields = [
    { key: 'faq_id',label:'ID', _style: { width: '20%'} },
    { key: 'user_type', _style: { width: '20%'} },
    { key: 'question', _style: { width: '55%'} },
    { key: 'delete',label:'', _style: { width: '5%'} },
]

class view extends Component {
	constructor(props) {
        super(props);
        this.state = {
        	showLoader:false,
        	faq:[],
        };
    }

    componentDidMount(){
		apiRequest({
            url: 'master/get-faqs',
            method: "GET",
        }).then((res) => {
            this.setState({ faq: res.data});
        })
        .catch((err) => {
            console.error("Error fetching states:", err?.response?.data?.message || err.message);
            alert(err?.response?.data?.message || "Failed to fetch states");
        });
	}

	handleDelete(faq_id) {
		apiRequest({
            url: 'master/delete-faq',
            method: "POST",
            data: JSON.stringify({faq_id})
        }).then((res) => {
            this.componentDidMount()
        })
        .catch((err) => {
            console.error("Error fetching states:", err?.response?.data?.message || err.message);
            alert(err?.response?.data?.message || "Failed to fetch states");
        });
	}

    render() {
	  	return (
	  		<CRow>
        		<CCol xs="12" md="12">
          			<CCard>
	            		<CCardBody>
	            			<p>
	            				<NavLink to="/faq/add" style={{ textDecoration: "none" }}>
									<CButton color="primary" className="px-4">
									    Add
									</CButton>
								</NavLink>
	            			</p>
						    <CDataTable
						      	items={this.state.faq}
						      	fields={fields}
						      	//columnFilter
						      	tableFilter
						      	footer
						      	//itemsPerPageSelect
						      	itemsPerPage={10}
						      	hover
						      	sorter
						      	pagination
						      	scopedSlots = {{
						      	// 'faq_id':
					          	// (item)=>(
						        //     <td>
						        //     	<Link to={{ pathname: "/faq/edit/"+item.faq_id }} > {item.faq_id}</Link>
						        //     </td>
					          	// ),
					          	'delete':
					          	(item)=>(
						            <td>
						            	<img alt="delete icon" src={deleteIcon} width="15" onClick={this.handleDelete.bind(this,item.faq_id)}/>
						            </td>
					          	),
						      	}}
						    />
			            </CCardBody>
		            </CCard>
		        </CCol>  
		    </CRow>      
	  	)
    }
}

export default view
